import {
  Grid, Star, UtensilsCrossed, Salad, Coffee, Cake, Pizza, Tag, Layers,
} from 'lucide-react';

const CATEGORY_ICONS = {
  all: Grid,
  popular: Star,
  main: UtensilsCrossed,
  appetizer: Salad,
  beverage: Coffee,
  dessert: Cake,
  sides: Pizza,
  _default: Tag,
};

// Categories grid (touch-mode) — visual tiles using each
// category's color/icon. Tap a tile to drill into its items.
export const PosCategoryGrid = ({ categories, onOpenCategory }) => (
  <div className="flex-1 px-4 py-4 overflow-y-auto pb-20 lg:pb-4" data-testid="pos-categories-view">
    <div className="grid gap-2 sm:gap-2.5 [grid-template-columns:repeat(auto-fit,minmax(104px,1fr))]">
      {categories.map((cat) => {
        const Icon = CATEGORY_ICONS[cat.id] || CATEGORY_ICONS._default;
        const tint = cat.color || '#8B5CF6';
        const rawImg = cat.image_url || null;
        const imgUrl = rawImg
          ? (rawImg.startsWith('/')
              ? `${process.env.REACT_APP_BACKEND_URL || ''}${rawImg.startsWith('/uploads/') ? '/api' + rawImg : rawImg}`
              : rawImg)
          : null;
        return (
          <button
            key={cat.id}
            onClick={() => onOpenCategory(cat.id)}
            className="group relative flex flex-col items-center justify-center gap-1.5 aspect-square rounded-xl text-white font-bold overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all"
            style={imgUrl
              ? { backgroundImage: `url(${imgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
              : { background: `linear-gradient(135deg, ${tint} 0%, ${tint}cc 100%)` }}
            data-testid={`pos-category-tile-${cat.id}`}
          >
            <div className={`absolute inset-0 pointer-events-none ${imgUrl ? 'bg-gradient-to-t from-black/70 via-black/30 to-black/10' : 'bg-gradient-to-t from-black/20 to-transparent'}`} />
            <div className="relative z-10 w-9 h-9 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <Icon size={20} />
            </div>
            <div className="relative z-10 text-center px-1.5 w-full">
              <div className="text-[11px] uppercase tracking-wide leading-tight drop-shadow-md line-clamp-2 break-words">{cat.name}</div>
              {typeof cat.item_count === 'number' && cat.item_count > 0 && (
                <div className="text-[9px] font-medium opacity-90 mt-0.5">{cat.item_count} items</div>
              )}
            </div>
          </button>
        );
      })}
      {categories.length === 0 && (
        <div className="col-span-full text-center py-12 text-muted-foreground">
          <Layers size={32} className="mx-auto mb-2 opacity-40" />
          <p className="text-sm">No categories yet — add menu items to populate.</p>
        </div>
      )}
    </div>
  </div>
);

export default PosCategoryGrid;
